import { createRouter, createWebHistory } from 'vue-router'

// 路由懒加载
const HomeView = () => import('../views/HomeView.vue')
const AboutView = () => import('../views/AboutView.vue')
const StrategyView = () => import('../views/StrategyView.vue')
const RiskComplianceView = () => import('../views/RiskComplianceView.vue')
const CrossBorderView = () => import('../views/CrossBorderView.vue')
const ContactView = () => import('../views/ContactView.vue')
const BusinessView = () => import('../views/BusinessView.vue')

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { title: '首页' }
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView,
    meta: { title: '关于我们' }
  },
  {
    path: '/strategy',
    name: 'strategy',
    component: StrategyView,
    meta: { title: '投资策略' }
  },
  {
    path: '/risk-compliance',
    name: 'risk-compliance',
    component: RiskComplianceView,
    meta: { title: '风控合规' }
  },
  {
    path: '/cross-border',
    name: 'cross-border',
    component: CrossBorderView,
    meta: { title: '跨境配置' }
  },
  {
    path: '/contact',
    name: 'contact',
    component: ContactView,
    meta: { title: '联络我们' }
  },
  {
    path: '/business',
    name: 'business',
    component: BusinessView,
    meta: { title: '业务介绍' }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

export default router
